import { defineMessages } from 'react-intl'

import { DEMAND } from './constants'

export const demandMessages = defineMessages({
  [DEMAND.N]: {
    id: 'demand.na',
    defaultMessage: 'N/A'
  },
  [DEMAND.D]: {
    id: 'demand.localNoStops',
    defaultMessage: 'Local no stops'
  },
  [DEMAND.L]: {
    id: 'demand.localWithStops',
    defaultMessage: 'Local with stops'
  },
  [DEMAND.I]: {
    id: 'demand.notLocalNoStops',
    defaultMessage: 'Not local no stops'
  },
  [DEMAND.T]: {
    id: 'demand.notLocalWithStops',
    defaultMessage: 'Not local with stops'
  }
})
